import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconBoundingBoxNew = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	clipRule: "evenodd",
	viewBox: "0 0 1024 1024",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M0 0h1024v1024H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 71.932448,
			d: "M897.156 746.366V489.465c-.032-22.897-12.3-44.123-32.113-55.555L640.254 305.459c-19.846-11.464-44.38-11.464-64.225 0l-224.79 128.45c-19.813 11.433-32.08 32.66-32.112 55.556v256.901c.032 22.897 12.3 44.123 32.113 55.555l224.789 128.451c19.845 11.464 44.38 11.464 64.225 0l224.789-128.45c19.814-11.433 32.08-32.66 32.113-55.556"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeMiterlimit: 1.4,
			strokeWidth: 71.9975243,
			d: "M203.908 81.256v289.109M59.356 225.812h289.109"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 71.932448,
			d: "m327.798 456.067 280.343 162.17 280.344-162.17M608.141 941.611V617.915"
		})
	]
});
export default SvgIconBoundingBoxNew;
